<template>
  <div>
    <v-data-table :headers="headers" :items="statuses">
      <template v-slot:top>
        <v-toolbar flat>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="create"> Dodaj </v-btn>
        </v-toolbar>
      </template>
      <template v-slot:[`item.name`]="props">
        <v-edit-dialog
          :return-value.sync="props.item.name"
          @save="save(props.item)"
          persistent
          large
          save-text="Shrani"
          cancel-text="Prekliči"
        >
          {{ props.item.name }}
          <template v-slot:input>
            <v-text-field
              v-model="props.item.name"
              label="Uredi"
              single-line
              counter
            ></v-text-field>
          </template>
        </v-edit-dialog>
      </template>
      <template v-slot:[`item.actions`]="{ item }">
        <TooltipIconButton
          tooltip="Izbriši"
          icon="mdi-delete"
          @click="remove(item)"
        ></TooltipIconButton>
      </template>
    </v-data-table>
  </div>
</template>
<script>
  import TooltipIconButton from "../TooltipIconButton.vue";
  export default {
    data: () => ({
      headers: [
        {
          text: "ID",
          align: "start",
          value: "id",
        },
        {
          text: "Ime",
          value: "name",
        },
        { text: "", value: "actions" },
      ],
      statuses: [],
    }),
    mounted() {
      this.loadEmployeeStatuses();
    },
    methods: {
      loadEmployeeStatuses() {
        this.$http.get("api/v1/employee-statuses").then((response) => {
          this.statuses = response.data;
        });
      },
      save(item) {
        this.$http
          .put("api/v1/employee-statuses/" + item.id, { name: item.name })
          .then((response) => {
            item.name = response.data.name;
          });
      },
      create() {
        this.$http
          .post("api/v1/employee-statuses", { name: "Nov status" })
          .then((response) => {
            this.statuses.push(response.data);
          });
      },
      remove(item) {
        this.$swal({
          title: "Pozor",
          text: "Ali ste prepričani da želite izbrisati status " + item.name,
          type: "warning",
          confirmButtonText: "Izbriši",
          cancelButtonText: "Prekliči",
          showCancelButton: true,
        }).then((value) => {
          if (value.value !== true) {
            return;
          }
          this.$http.delete("api/v1/employee-statuses/" + item.id).then(() => {
            this.loadEmployeeStatuses();
          });
        });
      },
    },
    components: { TooltipIconButton },
  };
</script>
<style></style>
